// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Index_copyright__zpM0n"};